// Global client error logger: local ring buffer + throttled report to /api/tenant/health/events
const API = process.env.REACT_APP_BACKEND_URL;
const LOG_KEY = "pos_error_log";
const IGNORE = [
  /ResizeObserver loop/i,
  /^Script error\.?$/i,
  /Loading chunk|ChunkLoadError/i,
  /Print Agent (unreachable|timed out|unavailable)/i,
  /NetworkError|Failed to fetch|Load failed|The user aborted/i,
];
let recentPosts = [];

function readLog() {
  try { return JSON.parse(localStorage.getItem(LOG_KEY) || "[]"); } catch { return []; }
}

export function getErrorLog() { return readLog(); }

export function logClientError(source, err, extra = "") {
  const message = String(err?.message || err || "").slice(0, 300);
  if (!message || IGNORE.some((re) => re.test(message))) return;
  const entry = {
    ts: new Date().toISOString(), source, message,
    stack: String(err?.stack || "").slice(0, 600),
    page: window.location.pathname, extra,
  };
  try {
    const log = readLog();
    log.unshift(entry);
    localStorage.setItem(LOG_KEY, JSON.stringify(log.slice(0, 50)));
  } catch { /* storage full */ }
  const now = Date.now();
  recentPosts = recentPosts.filter((p) => now - p.at < 60000);
  if (recentPosts.length >= 5 || recentPosts.some((p) => p.msg === message)) return;
  recentPosts.push({ at: now, msg: message });
  const token = localStorage.getItem("token");
  fetch(`${API}/api/tenant/health/events`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({ type: "js_error", source: `${source} ${window.location.pathname}`.slice(0, 60), message }),
  }).catch(() => {});
}

let initialized = false;
export function initErrorLogger() {
  if (initialized) return;
  initialized = true;
  window.addEventListener("error", (e) => logClientError("window", e.error || e.message));
  window.addEventListener("unhandledrejection", (e) => logClientError("promise", e.reason));
}
